import { render, staticRenderFns } from "./PurchasedItem.vue?vue&type=template&id=26173b41&scoped=true&"
import script from "./PurchasedItem.vue?vue&type=script&lang=js&"
export * from "./PurchasedItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedItem.vue?vue&type=style&index=0&id=26173b41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26173b41",
  null
  
)

export default component.exports